import axios from 'axios';

const URL_SUGGESTION_DEEP_SEARCH =
  'https://mon4-search.squiz.cloud/s/search.html';
const URL_SUGGESTION_COLLECTION_NAME = 'monash-faq-web-lean';

const faqApi = {
  searchByQuery(query) {
    const req = {
      collection: URL_SUGGESTION_COLLECTION_NAME,
      profile: '_default',
      num_ranks: '10',
      fmt: 'json++',
      form: 'faq',
      query,
    };
    return axios.get(URL_SUGGESTION_DEEP_SEARCH, {
      responseType: 'json',
      params: req,
    });
  },

  searchById(id) {
    const req = {
      collection: URL_SUGGESTION_COLLECTION_NAME,
      profile: '_default',
      num_ranks: '10',
      form: 'faq',
      meta_url: id,
    };
    return axios.get(URL_SUGGESTION_DEEP_SEARCH, {
      responseType: 'json',
      params: req,
    });
  },

  // remove see also
  // cleanAnswer(answer) {
  //   let cleaned = answer.replace(
  //     /<h2>(<strong>)?See also:(<\/strong>)?<\/h2>.*<ul><li><a href="\/article\/FAQ.*<\/a><\/li><\/ul>/,
  //     ''
  //   )
  //   return cleaned
  // },

  // fix links
  cleanAnswer(answer) {
    const cleaned = answer
      // ""
      .replace(
        /href="\/article\/FAQ/g,
        `href="https://connect.monash.edu/s/article/FAQ`,
      )
      // ''
      .replace(
        /href='\/article\/FAQ/g,
        `href='https://connect.monash.edu/s/article/FAQ`,
      );
    return cleaned;
  },
};

export default faqApi;
